import { generatePath } from "../generatePath";

const changePasswordRoute =
  "/patientManagement/patients/changeUserPassword/patient/:id";

const patientViewRoute = "/patientManagement/patients/view/:id";
const patientEditRoute = "/patientManagement/patients/edit/:id";
const patientCreateRoute = "/patientManagement/patients/create";

export const path = {
  changePassword: {
    route: changePasswordRoute,
    link: (id: string) => generatePath(changePasswordRoute, { id }),
  },
  patient: {
    route: "/patientManagement/patients",
    link: () => path.patient.route,
  },
  patientView: {
    route: patientViewRoute,
    link: (id: string) => generatePath(patientViewRoute, { id }),
  },
  patientEdit: {
    route: patientEditRoute,
    link: (id: string) => generatePath(patientEditRoute, { id }),
  },
  patientCreate: {
    route: patientCreateRoute,
    link: () => generatePath(patientCreateRoute),
  },
};
